import {
    IconName,
    IconPrefix,
    faCheck,
    faCheckSquare,
    faClock,
    faCommentDots,
    faEdit,
    faEnvelope,
    faEnvelopeOpen,
    faFileExcel,
    faFilePdf,
    faFilter,
    faGlobe,
    faHeadphones,
    faPlus,
    faSearch,
    faSearchDollar,
    faStreetView,
    faTimes,
    faTrash,
    faUsers,
    faVoicemail,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
    HistoricoClienteInterface,
    HistoricoInterface,
    IFiltroHistorico,
} from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import { ACESSOS } from "../../../../Routes/Acessos";
import {
    detectarTagsHtml,
    retirarTagsHtml,
} from "../../../../Tools/FormatTools";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";

import "moment/locale/pt-br";
import DOMPurify from "dompurify";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import AtualizarHistorico from "../AtualizarHistorico";
import {
    DeletarHistoricosController,
    ExportarExcelGenericoController,
    MarcarHistoricoLidoController,
} from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";

import Swal from "sweetalert2";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../Utils/OrSpinner";
import Timeline from "../../../Timeline";
import TimelineItem from "../../../Timeline/TimelineItem";
import FiltroHistorico from "./FiltroHistorico";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import saveAs from "file-saver";
import { ExportHTMLtoPDFController } from "../../../../Controllers/Geral/ContratosGerados/ContratosGeradosController";
import moment from "moment";
import CadastrarHistorico from "../CadastrarHistorico";
import {
    IconProp,
    findIconDefinition,
    library,
} from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import CasoAtividade from "./CasoAtividade";
import { ConcluirAtividadeVendasController } from "../../../../Controllers/Vendas/Caso/CasoController";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";

library.add(fas, fab);

type TTipoHistorico = "RESULTADO_CONTATO";

interface IPropsHistoricoCliente {
    historico: Array<HistoricoClienteInterface>;
    ID_CASO?: number;
    modificavel?: boolean;
    tipoHistorico?: TTipoHistorico;
    height?: number;
}
export interface IHistoricoClienteComTipoContato
    extends HistoricoClienteInterface {
    TIPO_CONTATO?:
        | "Contato Efetivo"
        | "Tentativa de Contato"
        | "Contato Não Efetivo"
        | "Outros";
    DS_TIPO_CASO:
        | "Atendimento Cliente"
        | "Cobrança"
        | "Outros"
        | "UAU"
        | "Helpdesk";
    ICON_KEY:
        | "Contato Efetivo"
        | "Tentativa de Contato"
        | "Contato Não Efetivo"
        | "Outros"
        | "Atendimento Cliente"
        | "Cobrança"
        | "UAU"
        | "Helpdesk";
}

const IconeDoHistoricoObject = {
    // Contatos
    "Contato Efetivo": {
        fa: faCheck,
        color: "success",
    } as const,
    "Tentativa de Contato": {
        fa: faVoicemail,
        color: "warning",
    } as const,
    "Contato Não Efetivo": {
        fa: faTimes,
        color: "danger",
    } as const,
    Outros: {
        fa: faCommentDots,
        color: "primary",
    } as const,
    //Casos
    "Atendimento Cliente": {
        fa: faUsers,
        color: "danger",
    } as const,
    Cobrança: {
        fa: faSearchDollar,
        color: "warning",
    } as const,
    Helpdesk: {
        fa: faWhatsapp,
        color: "success",
    },
    UAU: {
        fa: faGlobe,
        color: "info",
    },
    Ligação: {
        fa: faHeadphones,
        color: "info",
    },
} as const;

const LINK_CASO = {
    "Atendimento Cliente": {
        Link: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
    },
    Cobrança: {
        Link: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
    },
    Helpdesk: {
        Link: undefined,
    },
    Outros: {
        Link: undefined,
    },
    UAU: {
        Link: undefined,
    },
};

export default function ComponenteHistorico(props: IPropsHistoricoCliente) {
    const [filter, setFilter] = useState<IFiltroHistorico>({
        FL_SISTEMA_USUARIO: "cliente",
    });
    const [historicoFiltrado, setHistoricoFiltrado] = useState<
        Array<HistoricoClienteInterface>
    >(props.historico);

    const [loadingFilter, setLoadingFilter] = useState(false);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [modalCloseHistorico, setModalCloseHistorico] = useState(false);

    const { ReloadHistorico, LoadProximoHistoricoCliente, showLoadMoreButton } =
        useHistoricoContext();
    const { UserInfor } = useUserInfor();
    const { Atendimento } = useAtendimentoPage();

    function getIconFromString(iconString: string): IconProp | undefined {
        if (!iconString) return undefined;

        const parts = iconString.split(" ");
        const prefix = parts[0] as IconPrefix;

        const iconName = parts[1].split("-").slice(1).join("-") as IconName;

        const iconDefinition = findIconDefinition({ prefix, iconName });

        return iconDefinition;
    }

    const lstHistoricoComponente = useMemo(
        () => montarHistoricoCapys(historicoFiltrado, props.tipoHistorico),
        [props.tipoHistorico, historicoFiltrado]
    );

    const { execute: downloadHistoricoPdf } = useAsyncCallback(
        ExportHTMLtoPDFController
    );

    const { execute: downloadHistoricoExcel } = useAsyncCallback(
        ExportarExcelGenericoController
    );

    const {
        execute: ConcluirAtividadeVendas,
        loading: ConcluirAtividadeVendasLoading,
    } = useAsyncCallback(ConcluirAtividadeVendasController);

    const {
        execute: MarcarHistoricoLido,
        loading: MarcarHistoricoLidoLoading,
    } = useAsyncCallback(MarcarHistoricoLidoController);

    function converterFlagParaBoolean(flag: string | undefined) {
        if (flag === "sistema") {
            return true;
        } else if (flag === "cliente") {
            return false;
        } else {
            return filter?.FL_SISTEMA_USUARIO || false;
        }
    }
    const removeMsOutlookMobileSignature = (html: string) => {
        return html.replace(/<style.*?<\/style>/gi, "");
    };

    const htmlPdf = `
    <!DOCTYPE html>
    <html>
    <head>
        <title>Histórico</title>
        <meta charset='UTF-8'>
        <meta name='viewport' content='width=device-width, initial-scale=1.0'>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
            *, html,body{
                padding:0px;
                margin:0px;
                box-sizing:border-box;
                font-family:'Poppins', sans-serif;
                perspective:800px;
                border-radius: 10px;
            }
            body{
                width:100%;
                min-height:100vh;
                display:flex;
                justify-content:center;
                align-items:center;
            }
            .timeline{
                width:800px;
                background-color: #b5b5b5;
                color:#fff;
                padding:30px 20px;
                box-shadow:0px 0px 10px rgba(0,0,0,.5);
            }
            .timeline ul{
                list-style-type:none;
                border-left:2px solid white;
                padding:10px 5px;
            }
            .timeline ul li{
                padding:20px 20px;
                position:relative;
                transition:.5s;
            }
            .timeline ul li span{
                display:inline-block;
                color: #3c3c3c;
                border-radius:25px;
                padding:2px 5px;
                font-size:15px;
                text-align:center;
            }
            .timeline ul li .content h3{
                font-size:17px;
                padding-top:5px;
            }
            .timeline ul li .content p{
                padding:5px 0px 15px 0px;
                background-color: #feffd0;
                border-radius: 10px;
                padding:8px;
                color: #000000;
                font-size:15px;
            }
            @media (max-width:300px){
                .timeline{
                    width:100%;
                    padding:30px 5px 30px 10px;
                }
                .timeline ul li .content h3{
                    color: #000000;
                    font-size:15px;
                    border-radius: 10px;
                }
            
            }
        </style>
    </head>
    <body>
        <div class='timeline'>
            <ul>
                <li>
                    <div class='content'>
                        ${props.historico
                            .map(
                                (hist) => `
                            <h3>${hist.DS_USUARIO}</h3>
                            <span>${moment(hist.DT_CADASTRO).format(
                                "lll"
                            )}</span>
                            <p>
                                ${hist.DS_HISTORICO.replace(/<[^>]*>/g, "")}
                            </p>
                        `
                            )
                            .join("")}
                    </div>
                </li>
            </ul>
        </div>
    </body>
    </html>`;

    useEffect(() => {
        if (filter) {
            setHistoricoFiltrado(
                props.historico.filter(
                    (historicos) =>
                        (!filter?.ID_USUARIO ||
                            historicos.ID_USUARIO === filter?.ID_USUARIO) &&
                        (!filter?.FL_SISTEMA_USUARIO ||
                            historicos.FL_SISTEMA_USUARIO ===
                                converterFlagParaBoolean(
                                    filter?.FL_SISTEMA_USUARIO
                                )) &&
                        (!filter?.DT_INICIO ||
                            new Date(filter.DT_INICIO).getTime() <=
                                new Date(historicos.DT_CADASTRO).getTime()) &&
                        (!filter?.DT_FIM ||
                            new Date(filter.DT_FIM).getTime() >=
                                new Date(historicos.DT_CADASTRO).getTime()) &&
                        (!filter?.ID_TIPO_CASO ||
                            historicos.ID_TIPO_CASO ===
                                Number(filter.ID_TIPO_CASO))
                )
            );
        } else {
            setHistoricoFiltrado(props.historico);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, props.historico]);

    return (
        <>
            <div
                className="my-3 pl-3 pr-3 historico-container"
                style={{
                    height: props.height ?? 400,
                }}
            >
                <div className="row d-flex align-items-center justify-content-end mb-2 pr-4">
                    <div className="pr-3">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Filtro Histórico
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-dark"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Filtro Histórico",
                                        IconHeader: faFilter,
                                        Component: () => (
                                            <FiltroHistorico
                                                loadingFilter={loadingFilter}
                                                historico={props.historico}
                                                handleSubmit={(formData) => {
                                                    setLoadingFilter(true);
                                                    setFilter({
                                                        ...formData,
                                                    });

                                                    setTimeout(() => {
                                                        setLoadingFilter(false);
                                                    }, 300);
                                                }}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faFilter} />
                            </button>
                        </OverlayTrigger>
                    </div>
                    <div className="pr-3">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Exportar Histórico PDF
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-info"
                                onClick={() =>
                                    downloadHistoricoPdf({
                                        strHTML: htmlPdf,
                                    }).then((res) => {
                                        saveAs(res, `Historico.pdf`);
                                    })
                                }
                            >
                                <FontAwesomeIcon icon={faFilePdf} />
                            </button>
                        </OverlayTrigger>
                    </div>
                    <div>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Exportar Histórico Excel
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-success"
                                onClick={() => {
                                    downloadHistoricoExcel(
                                        props.historico.map((hist) => ({
                                            ID_CASO: hist.ID_CASO,
                                            DS_USUARIO:
                                                hist.DS_USUARIO ?? "Sistema",
                                            DT_CADASTRO: hist.DT_CADASTRO,
                                            DS_HISTORICO:
                                                hist.DS_HISTORICO.replace(
                                                    /<[^>]*>/g,
                                                    ""
                                                ),
                                        }))
                                    ).then((res) => {
                                        if (res) {
                                            const blob = new Blob([res], {
                                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                            });
                                            saveAs(blob, `Historico.xlsx`);
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faFileExcel} />
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <hr />

                <Timeline
                    itemList={lstHistoricoComponente}
                    keyGetter={(h) => `${h.ID_CASO_HISTORICO}`}
                    noDataIndication="Esse cliente não tem nenhum histórico registrado"
                >
                    {(historico) => {
                        const DS_IS_HTML = detectarTagsHtml(
                            historico.DS_HISTORICO.includes(
                                "ms-outlook-mobile-signature"
                            ) === true
                                ? removeMsOutlookMobileSignature(
                                      historico.DS_HISTORICO
                                  )
                                : historico.DS_HISTORICO
                        );
                        const DS_DESTINATARIO =
                            historico.DS_HISTORICO.split("Corpo:")[0];
                        const showDS = DS_IS_HTML
                            ? retirarTagsHtml(
                                  historico.DS_HISTORICO.includes(
                                      "ms-outlook-mobile-signature"
                                  ) === true
                                      ? removeMsOutlookMobileSignature(
                                            historico.DS_HISTORICO
                                        )
                                      : historico.DS_HISTORICO
                              )
                            : historico.DS_HISTORICO;
                        const historicoObj =
                            IconeDoHistoricoObject[
                                historico.TIPO_CONTATO || historico.DS_TIPO_CASO
                            ];
                        const iconProp = getIconFromString(
                            historico.DS_ICONE ? historico.DS_ICONE : ""
                        );

                        const link = LINK_CASO[historico.DS_TIPO_CASO].Link;
                        return (
                            <TimelineItem
                                date={new Date(historico.DT_CADASTRO)}
                                icon={iconProp ? iconProp : historicoObj.fa}
                                iconColor={historicoObj.color}
                                iconTooltipText={
                                    historico.TIPO_CONTATO ||
                                    historico.DS_TIPO_ATIVIDADE ||
                                    historico.DS_TIPO_CASO
                                }
                                className={
                                    historico.ID_CASO === props.ID_CASO
                                        ? "em-atendimento"
                                        : ""
                                }
                                title={historico.DS_USUARIO}
                                key={historico.ID}
                                subHeader={
                                    <div className="d-flex flex-wrap justify-content-end align-items-center g-2 w-100">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled">
                                                        Atendimento
                                                    </Tooltip>
                                                }
                                            >
                                                {historico.ID_CASO !==
                                                    props.ID_CASO && link ? (
                                                    <Link
                                                        to={
                                                            link
                                                                ? link(
                                                                      historico.ID_CASO
                                                                  )
                                                                : ""
                                                        }
                                                        className={`label font-weight-bolder label-inline ml-2 label-light-primary bg-hover-light-info text-hover-info`}
                                                    >
                                                        {historico.ID_CASO}
                                                    </Link>
                                                ) : !!historico.ID_CASO ? (
                                                    <span
                                                        className={`label font-weight-bolder label-inline ml-2 label-light-${
                                                            historico.ID_CASO ===
                                                            props.ID_CASO
                                                                ? "info"
                                                                : "primary"
                                                        }`}
                                                    >
                                                        {historico.ID_CASO}
                                                    </span>
                                                ) : (
                                                    <></>
                                                )}
                                            </OverlayTrigger>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center mb-0">
                                            {UserInfor.ID_USUARIO ===
                                                Atendimento?.ID_USUARIO_RESPONSAVEL && (
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            {historico.FL_LIDO
                                                                ? "Marcar como não lido"
                                                                : "Marcar como lido"}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <button
                                                        className={`btn text-${
                                                            historico.FL_LIDO
                                                                ? "success"
                                                                : "danger"
                                                        } btn-xs d-flex align-items-center justify-content-center flex-nowrap w-100`}
                                                        type="button"
                                                        onClick={() => {
                                                            if (
                                                                historico.ID_CASO_HISTORICO
                                                            ) {
                                                                MarcarHistoricoLido(
                                                                    historico.ID_CASO_HISTORICO,
                                                                    historico.FL_LIDO
                                                                        ? false
                                                                        : true
                                                                ).then(() => {
                                                                    ReloadHistorico();
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {MarcarHistoricoLidoLoading ? (
                                                            <Spinner size="sm" />
                                                        ) : (
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    historico.FL_LIDO
                                                                        ? faEnvelope
                                                                        : faEnvelopeOpen
                                                                }
                                                                size="lg"
                                                                className="mr-0"
                                                            />
                                                        )}
                                                    </button>
                                                </OverlayTrigger>
                                            )}
                                            {props.modificavel &&
                                                historico.FL_SISTEMA_USUARIO ===
                                                    false &&
                                                historico.ID_USUARIO ===
                                                    UserInfor.ID_USUARIO && (
                                                    <>
                                                        <div>
                                                            {historico.DS_TIPO_CASO !==
                                                                "UAU" &&
                                                            historico.ID_CASO_HISTORICO &&
                                                            !historico.DS_TIPO_ATIVIDADE ? (
                                                                <div className="d-flex">
                                                                    <button
                                                                        className="btn text-primary btn-xs d-flex align-items-center justify-content-center flex-nowrap w-100"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (
                                                                                historico.ID_CASO_HISTORICO
                                                                            ) {
                                                                                setShow(
                                                                                    true
                                                                                );
                                                                                setModal(
                                                                                    {
                                                                                        Children:
                                                                                            (
                                                                                                <AtualizarHistorico
                                                                                                    setShow={
                                                                                                        setShow
                                                                                                    }
                                                                                                    historico={
                                                                                                        historico as HistoricoInterface
                                                                                                    }
                                                                                                />
                                                                                            ),
                                                                                        noHeader:
                                                                                            true,
                                                                                        noFooter:
                                                                                            true,
                                                                                        size: "lg",
                                                                                    }
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faEdit
                                                                            }
                                                                            size="lg"
                                                                            className="mr-0"
                                                                        />
                                                                    </button>
                                                                </div>
                                                            ) : historico.ID_CASO_HISTORICO &&
                                                              historico.ID_TIPO_ATIVIDADE &&
                                                              !historico.FL_CONCLUIDO ? (
                                                                <>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Editar
                                                                                Atividade
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <button
                                                                            className="btn text-primary btn-xs d-flex align-items-center justify-content-center flex-nowrap w-100"
                                                                            type="button"
                                                                            onClick={() => {
                                                                                if (
                                                                                    historico.ID_CASO_HISTORICO &&
                                                                                    historico.DS_TIPO_ATIVIDADE &&
                                                                                    historico.DS_ICONE
                                                                                ) {
                                                                                    setShow(
                                                                                        true
                                                                                    );
                                                                                    setModal(
                                                                                        {
                                                                                            headerComponent:
                                                                                                "Cadastrar Atividade",
                                                                                            IconHeader:
                                                                                                faCheckSquare,
                                                                                            Component:
                                                                                                () => (
                                                                                                    <CasoAtividade
                                                                                                        setShow={
                                                                                                            setShow
                                                                                                        }
                                                                                                        row={
                                                                                                            historico
                                                                                                        }
                                                                                                    />
                                                                                                ),
                                                                                            size: "lg",
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faEdit
                                                                                }
                                                                                size="lg"
                                                                                className="mr-0"
                                                                            />
                                                                        </button>
                                                                    </OverlayTrigger>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                        <div>
                                                            {historico.ID_CASO_HISTORICO && (
                                                                <button
                                                                    className="btn text-danger btn-xs d-flex align-items-center justify-content-center flex-nowrap w-100"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        Swal.fire(
                                                                            {
                                                                                title: "Deseja apagar este histórico?",
                                                                                icon: "info",
                                                                                buttonsStyling:
                                                                                    false,
                                                                                confirmButtonText:
                                                                                    "<i class='la la-check'></i> Sim!",
                                                                                showCancelButton:
                                                                                    true,
                                                                                cancelButtonText:
                                                                                    "<i class='la la-thumbs-down'></i> Não",
                                                                                customClass:
                                                                                    {
                                                                                        confirmButton:
                                                                                            "btn btn-outline-success",
                                                                                        cancelButton:
                                                                                            "btn btn-default",
                                                                                    },
                                                                            }
                                                                        ).then(
                                                                            (
                                                                                result
                                                                            ) => {
                                                                                if (
                                                                                    result.isConfirmed &&
                                                                                    historico.ID_CASO_HISTORICO
                                                                                ) {
                                                                                    DeletarHistoricosController(
                                                                                        historico.ID_CASO_HISTORICO
                                                                                    ).then(
                                                                                        (
                                                                                            res
                                                                                        ) => {
                                                                                            ReloadHistorico();
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faTrash
                                                                        }
                                                                        size="lg"
                                                                        className="mr-0"
                                                                    />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                }
                                footer={
                                    historico.FL_CLIENTE_VISUALIZA_HISTORICO ? (
                                        <div className="d-flex flex-grow-1 flex-wrap justify-content-end align-items-center g-2 mt-n4">
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled">
                                                        Cliente visualiza
                                                    </Tooltip>
                                                }
                                            >
                                                <span>
                                                    <div className="text-success">
                                                        <FontAwesomeIcon
                                                            icon={faStreetView}
                                                        />
                                                    </div>
                                                </span>
                                            </OverlayTrigger>
                                        </div>
                                    ) : historico.ID_CASO_ATIVIDADE ||
                                      historico.ID_CASO_VISITA ? (
                                        <div className="mt-8">
                                            <hr className="m-0" />
                                            <div className="d-flex justify-content-between align-items-center m-0">
                                                <div className="d-flex flex-column">
                                                    {historico.DS_TIPO_ATIVIDADE && (
                                                        <div className="d-flex">
                                                            <span className="font-weight-bolder mr-1 mb-1">
                                                                Atividade:
                                                            </span>{" "}
                                                            {
                                                                historico.DS_TIPO_ATIVIDADE
                                                            }
                                                        </div>
                                                    )}

                                                    {historico.DT_CASO_ATIVIDADE && (
                                                        <>
                                                            <span className="mb-1">
                                                                Data:{" "}
                                                                {moment(
                                                                    historico.DT_CASO_ATIVIDADE
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                )}
                                                            </span>
                                                            <span className="mb-1">
                                                                Horário:{" "}
                                                                {moment(
                                                                    historico.DT_CASO_ATIVIDADE
                                                                ).format(
                                                                    "HH:mm"
                                                                ) === "00:00" &&
                                                                historico.DT_DURACAO
                                                                    ? moment(
                                                                          historico.DT_DURACAO,
                                                                          "HH:mm"
                                                                      ).format(
                                                                          "HH:mm"
                                                                      )
                                                                    : moment(
                                                                          historico.DT_CASO_ATIVIDADE
                                                                      ).format(
                                                                          "HH:mm"
                                                                      )}
                                                            </span>
                                                        </>
                                                    )}
                                                    {historico.FL_CONCLUIDO && (
                                                        <span className="mb-1">
                                                            {historico.FL_CONCLUIDO ? (
                                                                <>
                                                                    Atividade
                                                                    concluída{" "}
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faCheck
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    Atividade
                                                                    não
                                                                    concluída{" "}
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faClock
                                                                        }
                                                                    />
                                                                </>
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    {!historico.FL_CONCLUIDO &&
                                                        !historico.ID_CASO_VISITA && (
                                                            <button
                                                                className="btn text-success m-0 p-0"
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        title: "Deseja concluir essa atividade?",
                                                                        text: `Atividade: ${historico.DS_TIPO_ATIVIDADE}`,
                                                                        icon: "info",
                                                                        buttonsStyling:
                                                                            false,
                                                                        confirmButtonText:
                                                                            "<i class='la la-check'></i> Sim!",
                                                                        showCancelButton:
                                                                            true,
                                                                        cancelButtonText:
                                                                            "<i class='la la-thumbs-down'></i> Não",
                                                                        customClass:
                                                                            {
                                                                                confirmButton:
                                                                                    "btn btn-outline-success",
                                                                                cancelButton:
                                                                                    "btn btn-default",
                                                                            },
                                                                    }).then(
                                                                        (
                                                                            result
                                                                        ) => {
                                                                            if (
                                                                                result.isConfirmed &&
                                                                                historico.ID_CASO_ATIVIDADE
                                                                            ) {
                                                                                ConcluirAtividadeVendas(
                                                                                    [
                                                                                        {
                                                                                            ID_ATIVIDADE:
                                                                                                historico.ID_CASO_ATIVIDADE,
                                                                                            ID_CASO:
                                                                                                historico.ID_CASO,
                                                                                        },
                                                                                    ]
                                                                                ).then(
                                                                                    () => {
                                                                                        ReloadHistorico();
                                                                                    }
                                                                                );
                                                                            }
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                {ConcluirAtividadeVendasLoading ? (
                                                                    <>
                                                                        <Spinner size="sm" />{" "}
                                                                        Concluir
                                                                    </>
                                                                ) : (
                                                                    "Concluir"
                                                                )}
                                                            </button>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : undefined
                                }
                            >
                                {DS_IS_HTML ? (
                                    DS_IS_HTML[0].length < 100000 ? (
                                        <div className="p-0">
                                            <span
                                                className="text-primary btn p-0 mr-2 "
                                                onClick={() => {
                                                    setModal({
                                                        Component: () => (
                                                            <HistoricoTrocandoImagensDoDrivePorBase64
                                                                DS_HISTORICO={historico.DS_HISTORICO.replace(
                                                                    /<td/g,
                                                                    '<td style="border: 1px solid black; padding: 5px;"'
                                                                )}
                                                                DS_DESTINATARIO={
                                                                    historico.DS_HISTORICO.split(
                                                                        "Corpo:"
                                                                    )[1]
                                                                        ? DS_DESTINATARIO
                                                                        : ""
                                                                }
                                                            />
                                                        ),
                                                        noHeader: true,
                                                        noFooter: true,
                                                        size: "xl",
                                                        scrollable: true,
                                                    });
                                                    setShow(true);
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                />
                                            </span>
                                            <HistoricoTrocandoImagensDoDrivePorBase64
                                                DS_HISTORICO={historico.DS_HISTORICO.replace(
                                                    /<td/g,
                                                    '<td style="border: 1px solid black; padding: 5px;"'
                                                )}
                                                DS_DESTINATARIO={
                                                    historico.DS_HISTORICO.split(
                                                        "Corpo:"
                                                    )[1]
                                                        ? DS_DESTINATARIO
                                                        : ""
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <div className="p-0">
                                            <span
                                                className="text-primary btn p-0 mr-2 "
                                                onClick={() => {
                                                    setModal({
                                                        Component: () => (
                                                            <HistoricoTrocandoImagensDoDrivePorBase64
                                                                DS_HISTORICO={historico.DS_HISTORICO.replace(
                                                                    /<td/g,
                                                                    '<td style="border: 1px solid black; padding: 5px;"'
                                                                )}
                                                                DS_DESTINATARIO={
                                                                    historico.DS_HISTORICO.split(
                                                                        "Corpo:"
                                                                    )[1]
                                                                        ? DS_DESTINATARIO
                                                                        : ""
                                                                }
                                                            />
                                                        ),
                                                        noHeader: true,
                                                        noFooter: true,
                                                        size: "xl",
                                                        scrollable: true,
                                                    });
                                                    setShow(true);
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                />
                                            </span>
                                            <b>
                                                Este caso tem um conteúdo grande
                                                clique para visualizar
                                            </b>
                                        </div>
                                    )
                                ) : (
                                    <div
                                        className="p-0"
                                        style={{ whiteSpace: "pre-wrap" }}
                                    >
                                        <HistoricoTrocandoImagensDoDrivePorBase64
                                            DS_HISTORICO={showDS}
                                        />
                                    </div>
                                )}
                            </TimelineItem>
                        );
                    }}
                </Timeline>

                <br />

                {showLoadMoreButton && (
                    <div className="row d-flex align-items-center justify-content-center mb-2 pr-4">
                        <button
                            className="btn btn-primary"
                            onClick={LoadProximoHistoricoCliente}
                        >
                            Carregar mais antigos
                        </button>
                    </div>
                )}
            </div>
            {props.ID_CASO && (
                <button
                    className="w-100 btn btn-success font-weight-bold mt-5"
                    type="button"
                    onClick={() => {
                        setModalCloseHistorico(true);
                        setShow(true);
                        setModal({
                            headerComponent: "Cadastro de Histórico",
                            IconHeader: faCommentDots,
                            Component: () => (
                                <CadastrarHistorico setShow={setShow} />
                            ),
                            noHeader: false,
                            noFooter: true,
                            size: "lg",
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} size="lg" className="mr-2" />{" "}
                    Novo
                </button>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
                modalClose={modalCloseHistorico}
                setModalClose={setModalCloseHistorico}
            />
        </>
    );
}

interface IHistoricoTrocandoImagensDoDrivePorBase64Props {
    DS_HISTORICO: string;
    DS_DESTINATARIO?: string;
}

function HistoricoTrocandoImagensDoDrivePorBase64(
    props: IHistoricoTrocandoImagensDoDrivePorBase64Props
) {
    const { value: historicoComLinkDoDriveSubstituido, loading } =
        useAsyncEffect(async () => {
            // cria o template e coloca a string nele
            const template = document.createElement("template");
            template.innerHTML = props.DS_HISTORICO;

            // pega as imagens que tem src com link do drive
            const imgNodes = template.content.querySelectorAll(
                'img[src^="https://docs.google.com/uc?id="]'
            ) as NodeListOf<HTMLImageElement>;

            imgNodes.forEach((img) => {
                if (img.src.includes("https://docs.google.com/uc?id=")) {
                    // Substitui parte da URL para obter a miniatura do Google Drive
                    img.src = img.src.replace(
                        "https://docs.google.com/uc?id=",
                        "https://drive.google.com/thumbnail?id="
                    );
                    img.src += "&sz=w2000";
                }
            });

            // Retorna o conteúdo do template após a substituição
            return template.innerHTML;
        });

    return (
        <OrSpinner
            wrapperLoadingClasses="w-100 d-flex align-items-center justify-content-center"
            loading={loading}
            loadingColor="primary"
        >
            <span>{props.DS_DESTINATARIO}</span>
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                        historicoComLinkDoDriveSubstituido ?? props.DS_HISTORICO
                    ),
                }}
                className="modalHtml"
                style={{ position: "relative", zIndex: 0 }}
            ></div>
        </OrSpinner>
    );
}

function montarHistoricoCapys(
    lstHistorico: Array<HistoricoClienteInterface>,
    tipoHistorico?: TTipoHistorico
): Array<IHistoricoClienteComTipoContato> {
    return lstHistorico?.map((historico) => {
        const TIPO_CONTATO =
            tipoHistorico === "RESULTADO_CONTATO"
                ? historico.DS_HISTORICO.indexOf("Contato Efetivo") >= 0
                    ? "Contato Efetivo"
                    : historico.DS_HISTORICO.indexOf("Tentativa de Contato") >=
                      0
                    ? "Tentativa de Contato"
                    : historico.DS_HISTORICO.indexOf("Contato Não Efetivo") >= 0
                    ? "Contato Não Efetivo"
                    : "Outros"
                : undefined;

        const DS_TIPO_CASO =
            historico.DS_TIPO_CASO === "Atendimento Cliente"
                ? "Atendimento Cliente"
                : historico.DS_TIPO_CASO === "Cobrança"
                ? "Cobrança"
                : historico.ID_TIPO_CASO === ACESSOS.HELPDESK.ID_MODULO
                ? "Helpdesk"
                : "Outros";

        return {
            ...historico,
            TIPO_CONTATO,
            DS_TIPO_CASO,
            ICON_KEY: TIPO_CONTATO ?? DS_TIPO_CASO,
        } as IHistoricoClienteComTipoContato;
    });
}
